import React from 'react';
import ReactDOM from 'react-dom';
import { PRODUCTION, DEVELOPMENT } from '@src/constants/system';
import './index.module.scss';
import './styles/global.css';
import App from './App';

if (process.env.REACT_APP_STAGE === PRODUCTION) {
  const gtagScript = document.createElement('script');
  gtagScript.innerHTML = `(function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-KCBCBBG');`;
  document.head.appendChild(gtagScript);

  const gtagScript2 = document.createElement('noscript');
  const gtagScript3 = document.createElement('iframe');
  gtagScript3.setAttribute('src', 'https://www.googletagmanager.com/ns.html?id=GTM-KCBCBBG');
  gtagScript3.setAttribute('height', '0');
  gtagScript3.setAttribute('width', '0');
  gtagScript3.setAttribute('style', 'display:none;visibility:hidden');
  document.body.appendChild(gtagScript2).appendChild(gtagScript3);
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);